import lessRequire from '../../../config/less-require-resolver';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';
import { baseUrl } from '../../../config/route-entry-point';
import { getCurrencyIcon } from '../../../../shared/js/get-currency-icon';
import { formatMoney } from '../../shared/format';

import map from 'lodash/map';
import find from 'lodash/find';
import filter from 'lodash/filter';
import isEmpty from 'lodash/isEmpty';
import maxBy from 'lodash/maxBy';
import minBy from 'lodash/minBy';
import classname from 'classname';

lessRequire('modules/dashboard/components/offers.less');

const Offers = props => {
	const {
		data,
		currenciesForOffers,
		changeActiveCurrency,
		setQuidActive,
		intl
	} = props;

	return (<div className="offers-list clearfix">
		{ data.map(item => {
			let payoutFiltered = [];
			let activeCurrencyForOffer;
			let payout = item && item.payouts && item.payouts[0].amount;
			let min;
			let max;
			const isShowedQuids = process.env.CPA_ENV === 'rocket' &&
				item.locations.length && item.locations.some(loc => loc.is_contest_enabled);

			const maxPointLocation = isShowedQuids && maxBy(
				filter(item.locations, l => !!l.is_contest_enabled), l => l.contest_points
			);
			const minPointLocation = isShowedQuids && minBy(
				filter(item.locations, l => !!l.is_contest_enabled), l => l.contest_points
			);

			const activeCurrency = find(currenciesForOffers.data, r => r.id == item.id);
			const isActiveCurrencyQuid = activeCurrency && activeCurrency.currency === 'Q';
			if (activeCurrency) {
				payoutFiltered = filter(item.payouts, p => p.currency == activeCurrency.currency);
				activeCurrencyForOffer = !isEmpty(payoutFiltered) ? activeCurrency.currency : item.payouts[0].currency;
			} else {
				activeCurrencyForOffer = find(item.payouts, p => p.currency == currenciesForOffers.activeBalance)
					? currenciesForOffers.activeBalance : item.payouts && item.payouts[0].currency;
				payoutFiltered = filter(item.payouts, p => p.currency == activeCurrencyForOffer);
			}

			if (payoutFiltered.length == 1) {
				payout = payoutFiltered[0].amount;
			} else {
				if (!isEmpty(payoutFiltered)) {
					min = minBy(payoutFiltered, 'amount').amount;
					max = maxBy(payoutFiltered, 'amount').amount;
				}
			}

			let renderedCurrencies = [];
			const isHiddenRocketOfferCR = process.env.CPA_ENV === 'rocket' &&
				(item.is_new || !item.is_enough_leads_to_show);

			return (<Link key={item.id} to={baseUrl('offers/' + item.id + '/')} className="offers-list__item">
				<div className="offers-list__item-border" />
				<img
					src={ item.image || '//placehold.it/160x160' }
					className='offers-list__item-image'
					alt={ item.title }
				/>
				<div className="title font-proxima-nova-semibold">{ item.title }</div>
				<div className="subtitle font-proxima-nova">{ item.subtitle }</div>

				{<div className="offers-list__item-currencies">
					{map(item.payouts, (p, i) => {
						const className = classname({
							'currency_icon': true,
							'active': !isActiveCurrencyQuid && p.currency == activeCurrencyForOffer
						});
						const isRendered = !!find(renderedCurrencies, c => c == p.currency);
						if (!isRendered) {
							renderedCurrencies.push(p.currency);
						}

						return !isRendered
							? (
								<span key={`${i} ${item.id}`} className={className}
									onClick={e => {
										e.preventDefault();
										e.stopPropagation();
										changeActiveCurrency(p.currency, item.id);
									}}
								>{getCurrencyIcon(p.currency)}</span>
							)
							: null;
					})}
					{Boolean(isShowedQuids) && (
						<span
							className={`currency_icon ${isActiveCurrencyQuid && 'active'}`}
							onClick={e => {
								e.preventDefault();
								e.stopPropagation();
								setQuidActive(item.id);
							}}
						>
									Q
						</span>
					)}
				</div>}
				{ process.env.CPA_ENV !== 'everad' && <div className="offers-list__item-property">
					<span className="offers-list__item-property-title">CR</span>
					<span className="offers-list__item-property-value font-proxima-nova-semibold">
						{ (parseFloat(item.cr) > 0 ||
							process.env.CPA_ENV === 'rocket') &&
							!isHiddenRocketOfferCR ? `${item.cr} %` : intl('NEW!') }
					</span>
				</div> }
				{ process.env.CPA_ENV !== 'everad' && <div className="offers-list__item-property">
					<span className="offers-list__item-property-title">{intl('Подтверждение')}</span>
					<span className="offers-list__item-property-value font-proxima-nova-semibold">
						{ (parseFloat(item.approve) > 0 ||
							process.env.CPA_ENV === 'rocket') &&
							!isHiddenRocketOfferCR ?
							`${Math.floor(item.approve)} %` : intl('NEW!') }
					</span>
				</div> }
				{<div className="offers-list__item-property">
					<span className="offers-list__item-property-title">
						{!isActiveCurrencyQuid ? intl('Выплаты') : 'QUID'}
					</span>
					<span className="offers-list__item-property-value font-proxima-nova-semibold">
						{ !isActiveCurrencyQuid && (payoutFiltered.length == 1
							? (<span>{formatMoney(payout)}
								<span className="currency">{getCurrencyIcon(activeCurrencyForOffer)}</span></span>)
							: !isEmpty(payoutFiltered) && min != max
								? (<span>{formatMoney(min)}
									<span className="currency">{getCurrencyIcon(activeCurrencyForOffer)}</span> - {formatMoney(max)}
									<span className="currency">{getCurrencyIcon(activeCurrencyForOffer)}</span></span>)
								: !isEmpty(payoutFiltered)
									? (<span>{formatMoney(max)}
										<span className="currency">{getCurrencyIcon(activeCurrencyForOffer)}</span></span>)
									: (<span>{formatMoney(payout)}
										<span className="currency">{getCurrencyIcon(activeCurrencyForOffer)}</span></span>)
						)}
						{isActiveCurrencyQuid && (
							maxPointLocation.contest_points === minPointLocation.contest_points ?
								<span> { minPointLocation.contest_points }
									<span className="currency">Q</span>
								</span>:
								<span>
									{`${minPointLocation.contest_points} - ${maxPointLocation.contest_points}`}
								</span>
						)}
					</span>
				</div>
				}
			</Link>);
		})}
	</div>);
};

Offers.propTypes = {
	data: PropTypes.array,
	currenciesForOffers: PropTypes.object,
	changeActiveCurrency: PropTypes.func,
	setQuidActive: PropTypes.func,
	intl: PropTypes.func
};

export default  Offers;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/dashboard/components/offers.js